import Vue from 'vue';
import Component from 'vue-class-component';
import starFillSVG from 'common/icons/StarFill.svg';
import starGraySVG from 'common/icons/StarGray.svg';
import ratingSVG from 'common/icons/rating.svg';

@Component({
  props: {
    value: {
      required: true,
    },
    maxValue: {
      default: 5,
      type: Number,
    },
    allStars: {
      default: false,
      type: Boolean,
    },
    valueFontSize: {
      default: '16px',
      type: String,
    },
    starSize: {
      default: '--small',
      type: String,
    },
    lineHeight: {
      default: '1.0',
      type: String,
    },
    totalOpinions: {
      type: Number,
    },
    showStart: {
      type: Boolean,
      default: true,
    },
    showTotalOpinions: {
      type: String,
      default: '',
      description:
        '--mobile, --desktop or --always determines when totalOpinions has to be displayed',
    },
    showRatingNumber: {
      type: Boolean,
      default: true,
    },
    allStarsDesktop: {
      default: false,
      type: Boolean,
    },
    isCard: {
      type: Boolean,
      required: false,
    },
    starOnTheRight: {
      type: Boolean,
      default: false,
    },
    numberBold: {
      type: Boolean,
      required: false,
    },
  },
})
export default class RatingComponent extends Vue {
  starFillIcon = starFillSVG;
  starGrayIcon = starGraySVG;
  ratingSVG = ratingSVG;

  getDecimal(index) {
    const { value } = this;
    const integer = Math.floor(value);
    if (integer >= index) {
      return 10;
    }
    if (integer + 1 < index) {
      return 0;
    }
    return Math.floor((value % 1) * 10);
  }
}
